import 'react-simple-keyboard/build/css/index.css';
import './app.css';
import { Button, Col, Row, Toast } from 'react-materialize';
import React, { useEffect, useState } from 'react';
import SideBarView from '../sidebar/sidebar.view';
import NavigationView from '../navigation/navigation.view';
import LoadingView from '../loading/loading.view';
import PedidoView from '../pedido/pedido.view';
import PedidoPrintView from '../pedido-print/pedido-print.view';
import ProductView from '../product/product.view';
import Category from '../category/category.view';
import Swal from 'sweetalert2';


 

const AppView = (props) => {
  const [progress, setProgress] = useState(0);
  const [goal, setGoal] = useState(100);
  const [newClients, setNewClients] = useState(0);
  const [updateNeeded, setUpdateNeeded] = useState(false);
  const user = JSON.parse(localStorage.getItem('user'));
  const currentUserId = user?.salesPersonId;
  const departmentId = user?.departmentId;

  useEffect(() => {
    if (!currentUserId) return;

    const fetchData = async () => {
      try {
        const salesResponse = await fetch(`http://miplayera2.dyndns.org:8810/gmpPlatforms/rest/kpi/weekPrincipalIndicator?salesPersonId=${currentUserId}`);
        const salesData = await salesResponse.json();
        if (salesData.result?.[0]?.data?.[0]) {
          setProgress(salesData.result[0].data[0].sale);
          setGoal(salesData.result[0].data[0].saleObjetive);
          setNewClients(salesData.result[0].data[0].clientQty);
        }
      } catch (error) {
        console.error('Error al obtener los datos:', error);
      }
    };

    fetchData();
  }, [currentUserId]);

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value);
  };

  const canViewData = departmentId === '003' || departmentId === '005' || departmentId === '001' || departmentId === '008';
 
  useEffect(() => {
    const checkVersion = async () => {
      try {
        const response = await fetch("/version.json?_=" + Date.now());
        const data = await response.json();
        const currentVersion = localStorage.getItem("app_version");

        if (!currentVersion) {
          localStorage.setItem("app_version", data.version);
        } else if (currentVersion !== data.version) {
          setUpdateNeeded(true);
        }
      } catch (err) {
        console.error("Error verificando versión:", err);
      }
    };

    checkVersion();
    const interval = setInterval(checkVersion, 60 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (updateNeeded) {
      Swal.fire({
        title: "¡Reinicia la sesión!",
        text: "Hay una nueva versión disponible",
        icon: "info",
        confirmButtonText: "Ok"
      })
    }
  }, [updateNeeded]);

  const confirmLogout = async (e) => {
    if (e && typeof e.preventDefault === 'function') e.preventDefault();
    if (e && typeof e.stopPropagation === 'function') e.stopPropagation();
  
    const { isConfirmed } = await Swal.fire({
      title: '¿Cerrar sesión?',
      text: 'Se cerrará tu sesión y podrías perder cambios no guardados.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, cerrar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      focusCancel: true,
      allowOutsideClick: false,
      heightAuto: false
    });
  
    if (!isConfirmed) return;
  
    try {
      if (typeof props.cerrarSesion === 'function') {
        await props.cerrarSesion();
      }
    } catch (err) {
      console.error('Error al cerrar sesión:', err);
    } finally {
      setTimeout(() => {
        window.location.href = window.location.pathname + '?_=' + Date.now();
      }, 300);
    }
  };
  
  return (
<>
  <div className="app">
    <Row>
      <Col s={12} m={12} l={12} xl={12}>
        <div className="main-container">
          {canViewData ? (
            <>
              <div className="stats-container">

                <div className="objective-container">
                  <p className="stats-title">OBJETIVO MENSUAL</p>

                  <div className="progress-wrapper">
                    <span>{formatCurrency(progress)}</span>
                    <progress value={progress} max={goal}></progress>
                    <span>{formatCurrency(goal)}</span>
                  </div>

                  <div className="progress-percentage">
                    <span>{((progress / goal) * 100).toFixed(2)}%</span>
                  </div>
                </div>

                <div className="clients-container">
                  <p className="clients-title">CLIENTES NUEVOS</p>
                  <span className="clients-count">{newClients}</span>
                </div>

              </div>
            </>
          ) : (
            <p></p>
          )}
        </div>
      </Col>
    </Row>
  </div>



      <div
        className={
          props.print ||
          props.modalOCIsOpen ||
          props.modalRackIsOpen ||
          props.modalFaqIsOpen ||
          props.modalCancelIsOpen ||
          props.modalPedidosIsOpen ||
          props.modalCheckinIsOpen ||
          props.modalReporteIsOpen ||
          props.modalReporte2IsOpen ||
          props.modalInvoicesIsOpen ||
          props.modalRemisionIsOpen ||
          props.modalScheduleIsOpen ||
          props.modalArticulosIsOpen ||
          props.modalOCByBrandIsOpen ||
          props.modalIndicatorsIsOpen ||
          props.modalInventoryLookupIsOpen ||
          props.modalExistencesIsOpen ||
          props.modalCambioPreciosIsOpen ||
          props.modalCheckinRepIsOpen ||
          props.modalRemoteOrdersIsOpen ||
          props.modalForaneosIsOpen ||
          props.modalForaneosRepIsOpen ||
          props.modalWarehouseAgentsIsOpen ||
          props.modalNewCustomerIsOpen
            ? 'hidden'
            : 'button-action-containers'
        }
      >
        <Button
          floating
          large
          waves="light"
          className="help_button"
          onClick={props.scrolloToTop}
          icon="keyboard_arrow_up"
        />
        <Button
          floating
          large
          waves="light"
          className="help_button"
          onClick={props.scrolloToBottom}
          icon="keyboard_arrow_down"
        />
        <Button
          floating
          large
          waves="light"
          className="help_button"
          onClick={props.openPedido}
          icon="shopping_cart"
        />
        <div style={{"opacity":0}}>
          <Button
            floating
            large
            waves="light"
            className="help_button"
            onClick={props.openPedido}
            icon='pin_drop'
            disabled={true}
          />
        </div>

        <Button
  node="button"
  floating
  large
  waves="light"
  className="help_button"
  icon="exit_to_app"
  title="Salir"
  onClick={confirmLogout}
/>
      </div>

<Row>
        <Col
          s={10}
          offset="s1 m1"
        >
        {props.print ? 'hidden' : ''}
          <div className="breadcrum">
            <ul
              className="nav nav-tabs process-model more-icon-preocess"
              role="tablist"
            >
              <NavigationView
                navigations={props.navigations}
                familyId={props.familyId}
                brandId={props.brandId}
                genderId={props.genderId}
                styleId={props.styleId}
                modelId={props.modelId}
                brandsClass={props.brandsClass}
                gendersClass={props.gendersClass}
                stylesClass={props.stylesClass}
                modelsClass={props.modelsClass}
                productsClass={props.productsClass}
                brandsName={props.brandsName}
                gendersName={props.gendersName}
                stylesName={props.stylesName}
                modelsName={props.modelsName}
                productsName={props.productsName}
                showPedido={props.showPedido}
                hiddenPedido={props.hiddenPedido}
                getCategoryData={props.getCategoryData}
              />

              <div className="select-elements">
                {props.familyName ? (
                  <div className="select-elements-item">
                    {' - ' + props.familyName.toUpperCase() + ' - '}
                  </div>
                ) : (
                  <div />
                )}
                {props.brandsName ? (
                  <div className="select-elements-item">
                    {props.brandsName.toUpperCase() + ' - '}
                  </div>
                ) : (
                  <div />
                )}
                {props.gendersName ? (
                  <div className="select-elements-item">
                    {props.gendersName.toUpperCase() + ' - '}
                  </div>
                ) : (
                  <div />
                )}
                {props.stylesName ? (
                  <div className="select-elements-item">
                    {props.stylesName.toUpperCase() + ' - '}
                  </div>
                ) : (
                  <div />
                )}
                {props.modelsName ? (
                  <div className="select-elements-item">
                    {props.modelsName.toUpperCase() + ' - '}
                  </div>
                ) : (
                  <div />
                )}
              </div>
            </ul>
          </div>
          
        </Col>
        <Row>
          <Col
            s={1}
            m={1}
            l={1}
            xl={1}
            className={
              props.geoUrlIsOpen||
              props.print ||
              props.modalRemisionIsOpen ||
              props.modalPedidosIsOpen ||
              props.modalExistencesIsOpen ||
              props.modalCambioPreciosIsOpen ||
              props.modalArticulosIsOpen ||
              props.modalReporteIsOpen ||
              props.modalReporte2IsOpen ||
              props.modalCancelIsOpen ||
              props.modalIndicatorsIsOpen ||
              props.modalOCByBrandIsOpen ||
              props.modalInvoicesIsOpen ||
              props.modalNewCustomerIsOpen ||
              props.modalFaqIsOpen ||
              props.modalCheckinIsOpen ||
              props.modalCheckinRepIsOpen ||
              props.modalScheduleIsOpen ||
              props.modalMaintenaceIsOpen||
              props.modalOCIsOpen||
              props.modalRemoteOrdersIsOpen ||
              props.modalForaneosIsOpen ||
              props.modalForaneosRepIsOpen ||
              props.modalWarehouseAgentsIsOpen ||

              props.modalRackIsOpen
                ? 'hidden'
                : ''
            }
          >
            <SideBarView
              {...props}
            />
          </Col>
          <Col s={10} offset="s1 m1">
            <div className="body">
              {props.loading ? (
                <LoadingView />
              ) : props.showPedido ? (
                <div>
                  <div
                    className={
                      props.geoUrlIsOpen||
                      props.print ||
                      props.modalRemisionIsOpen ||
                      props.modalPedidosIsOpen ||
                      props.modalArticulosIsOpen ||
                      props.modalExistencesIsOpen ||
                      props.modalCambioPreciosIsOpen ||
                      props.modalReporteIsOpen ||
                      props.modalReporte2IsOpen ||
                      props.modalCancelIsOpen ||
                      props.modalIndicatorsIsOpen||
                      props.modalOCByBrandIsOpen ||
                      props.modalInvoicesIsOpen ||
                      props.modalNewCustomerIsOpen ||
                      props.modalFaqIsOpen ||
                      props.modalCheckinIsOpen ||
                      props.modalCheckinRepIsOpen ||
                      props.modalScheduleIsOpen ||
                      props.modalMaintenaceIsOpen||
                      props.modalOCIsOpen ||
                       props.modalRemoteOrdersIsOpen ||
                       props.modalForaneosIsOpen ||
                       props.modalForaneosRepIsOpen ||
                       props.modalWarehouseAgentsIsOpen ||

                       props.modalRackIsOpen 
                        ? 'hidden'
                        : ''
                    }
                  >
                    <PedidoView
                      {...props}
                      catalog={props.catalog}
                      total={props.total}
                      cantidad={props.cantidad}
                      envios={props.envios}
                      cliente={props.cliente}
                      clienteSeleccionado={props.clienteSeleccionado}
                      clientes={props.catalog.customers}
                      newAgente={props.newAgente}
                      setNuevoAgente={props.setNuevoAgente}
                      comentarioPedido={props.comentarioPedido}
                      descuentoPedido={props.descuentoPedido}
                      envioSeleccionado={props.envioSeleccionado}
                      productosLocalStorage={props.productosLocalStorage}
                      setPriceProductosLocalStorage={
                        props.setPriceProductosLocalStorage
                      }
                      eliminarPartida={props.eliminarPartida}
                      cambiarCantidad={props.cambiarCantidad}
                      regresarArticulos={props.regresarArticulos}
                      agregarEnvio={props.agregarEnvio}
                      seleccionarCliente={props.seleccionarCliente}
                      onSelectAgente={props.onSelectAgente}
                      onChangeSelectedCliente={props.onChangeSelectedCliente}
                      onChangeComentarioPedido={props.onChangeComentarioPedido}
                      onChangeDescuento={props.onChangeDescuento}
                      onSelectEnvio={props.onSelectEnvio}
                      colocarPedido={props.colocarPedido}
                      setActiveInput={props.setActiveInput}
                      openPedido={props.openPedido}
                      opengps={props.opengps}
                      setPriceByProduct={props.setPriceByProduct}
                    />
                  </div>
                  <div
                    style={{ width: '100% !important' }}
                    className={props.print ? '' : 'hidden'}
                  >
                    <PedidoPrintView {...props} />
                  </div>
                </div>
              ) : props.showProduct && 
                  !props.modalRemisionIsOpen &&
                  !props.modalPedidosIsOpen &&
                  !props.modalArticulosIsOpen &&
                  !props.modalExistencesIsOpen &&
                  !props.modalCambioPreciosIsOpen &&
                  !props.modalReporteIsOpen &&
                  !props.modalReporte2IsOpen &&
                  !props.modalReporte2IsOpen && 
                  !props.modalCancelIsOpen &&
                  !props.modalIndicatorsIsOpen &&
                  !props.modalOCByBrandIsOpen &&
                  !props.modalInvoicesIsOpen &&
                  !props.modalNewCustomerIsOpen &&
                  !props.modalFaqIsOpen &&
                  !props.modalCheckinIsOpen &&
                  !props.modalCheckinRepIsOpen &&
                  !props.modalScheduleIsOpen &&
                  !props.modalMaintenaceIsOpen &&
                  !props.modalOCIsOpen &&
                  !props.modalRemoteOrdersIsOpen &&   
                 !props.modalForaneosIsOpen &&
                 !props.modalForaneosRepIsOpen &&
                 !props.modalWarehouseAgentsIsOpen &&
                  !props.modalRackIsOpen 
                    ? (
                <ProductView
                  catalog={props.catalog}
                  product={props.product}
                  productos={props.productos}
                  pantones={props.pantones}
                  locations={props.locations}
                  locationsAvailable={props.locationsAvailable}
                  inventories={props.inventories}
                  coloresServicio={props.coloresServicio}
                  image={props.image}
                  tallas={props.tallas}
                  tallaSeleccionada={props.tallaSeleccionada}
                  colorSeleccionado={props.colorSeleccionado}
                  cantidadSeleccionada={props.cantidadSeleccionada}
                  botonBloqueado={props.botonBloqueado}
                  existenColores={props.existenColores}
                  colorId={props.colorId}
                  colores={props.colores}
                  existencia={props.existencia}
                  existencia2={props.existencia2}
                  existencia3={props.existencia3}
                  existencia4={props.existencia4}
                  exceptColorNewMedList={props.exceptColorNewMedList}
                  colorHidden={props.colorHidden}
                  onChangeTalla={props.onChangeTalla}
                  onChangeColor={props.onChangeColor}
                  onChangeColorTallas={props.onChangeColorTallas}
                  getTallasExistencias={props.getTallasExistencias}
                  onChangeCantidad={props.onChangeCantidad}
                  setActiveInput={props.setActiveInput}
                  insertIntoLocalStorage={props.insertIntoLocalStorage}
                  getArticulosRelacionados={props.getArticulosRelacionados}
                  getMarcasRelacionadas={props.getMarcasRelacionadas}
                  onClickElement={props.onClickElement}
                  changeProductClassEmpty={props.changeProductClassEmpty}
                  changeProductViewIds={props.changeProductViewIds}
                  brandId={props.brandId}
                  imageRute={props.imageRute}
                  changeImageRute={props.changeImageRute}
                  getPriceByPriceListKey={props.getPriceByPriceListKey}
                  url={props.url}
                  urlPass={props.urlPassSquare}
                  urlfaq={props.urlPassSquare}
                  urlfaq1={props.urlPassSquare}
                />
              ) : (
                <Category
                  imageRute={props.imageRute}
                  elements={props.elements}
                  onClickElement={props.onClickElement}
                  modalRemisionIsOpen={props.modalRemisionIsOpen}
                  modalPedidosIsOpen={props.modalPedidosIsOpen}
                  openModalPedidos={props.openModalPedidos}
                  closeModalRemision={props.closeModalRemision}
                  closeModalPedidos={props.closeModalPedidos}
                  modalArticulosIsOpen={props.modalArticulosIsOpen}
                  openModalArticulos={props.openModalArticulos}
                  closeModalArticulos={props.closeModalArticulos}
                  modalIndicatorsIsOpen={props.modalIndicatorsIsOpen}
                  modalIndicatorsIsClose={props.modalIndicatorsIsClose}
                  modalMaintenaceIsOpen={props.modalMaintenaceIsOpen}
                  modalMaintenaceIsClose={props.modalMaintenaceIsClose}
                  modalRemoteOrdersIsOpen={props.modalRemoteOrdersIsOpen}
                  modalRemoteOrdersIsClose={props.modalRemoteOrdersIsClose}
                  modalForaneosIsOpen={props.modalForaneosIsOpen}
                  modalForaneosIsClose={props.modalForaneosIsClose}
                  modalForaneosRepIsOpen={props.modalForaneosRepIsOpen}
                  modalForaneosRepOpen={props.modalForaneosRepOpen}
                  closeModalForaneosRep={props.closeModalForaneosRep}
                  jsCalendarIsOpen={props.jsCalendarIsOpen}
                  jsCalendarIsClose={props.jsCalendarIsClose}


                />
              )}
            </div>
          </Col>
        </Row>
      </Row>
            
      <div className="hidden">
        <Toast
          options={{
            html: `Se agrego el articulo al pedido !`,
            classes: 'message',
          }}
        >
          articulo
        </Toast>
        <Toast
          options={{
            html: `Se actualizo cantidad de articulo en el pedido !`,
            classes: 'message',
          }}
        >
          mod_articulo
        </Toast>
        <Toast
          options={{
            html: `El articulo no se encuentra en existencia !`,
            classes: 'message-error',
          }}
        >
          existencia
        </Toast>
        <Toast
          options={{
            html: `No hay inventario suficiente para tu pedido, favor de pasar al mostrador para completar tu pedido !`,
            classes: 'message-error',
          }}
        >
          stock
        </Toast>
        <Toast
          options={{
            html: `No hay inventario suficiente para tu pedido !`,
            classes: 'message-error',
          }}
        >
          stock_articulo
        </Toast>
        <Toast
          options={{
            displayLength: 20000,
            html: `Se generó correctamente el pedido con número: ${props.numeroPedido} !`,
            classes: 'message',
          }}
        >
          pedido
        </Toast>
        <Toast
          options={{
            html: `Se agrego el envio al pedido !`,
            classes: 'message',
          }}
        >
          envio
        </Toast>
        <Toast
          options={{
            html: `Ocurrio un error, intentalo nuevamente !`,
            classes: 'message-error',
          }}
        >
          error
        </Toast>
      </div>
    </>
  );
  
};

export { AppView as default };
